export default {"src":"/_next/static/media/aspirants-vector.4455284f.svg","height":112,"width":552,"blurWidth":0,"blurHeight":0};